export default {
    SET_STATUS: 'SET_STATUS',
    SET_CAMERA_AZIMUTH: 'SET_CAMERA_AZIMUTH',
    ALL_MAP_BUTTONS_DISABLED_STATE: 'ALL_MAP_BUTTONS_DISABLED_STATE',
    ALL_MAP_BUTTONS_ENABLED_STATE: 'ALL_MAP_BUTTONS_ENABLED_STATE',
};
